import React, { createContext, useContext, useMemo, useState } from 'react';
import type { ImageId } from '../../assets/marketing/manifest';
import type { VideoId } from '../content/videos';

export interface HeroRequest {
  image: ImageId | null;
  alt: string;
  /** A film to play over the photograph, which is then its still. */
  video?: VideoId;
}

interface HeroContextValue {
  hero: HeroRequest;
  setHero: (hero: HeroRequest) => void;
}

const HeroContext = createContext<HeroContextValue | null>(null);

/**
 * Pages declare which photograph they open on (<Hero image=… video=…/>); the
 * persistent HeroStage in the layout renders it and crossfades between
 * pages. Keeping the stage mounted across routes is what makes a navigation
 * a dissolve rather than a cut.
 */
export function HeroProvider({ children }: { children: React.ReactNode }) {
  const [hero, setHero] = useState<HeroRequest>({ image: null, alt: '' });
  const value = useMemo(() => ({ hero, setHero }), [hero]);
  return <HeroContext.Provider value={value}>{children}</HeroContext.Provider>;
}

export const useHeroContext = () => useContext(HeroContext);
